import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type GetUserProfileQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type GetUserProfileQuery = { __typename?: 'Query' } & {
    user?: Types.Maybe<
        { __typename?: 'User' } & Pick<Types.User, 'loggedIn' | 'userId'> & {
                profile?: Types.Maybe<
                    { __typename?: 'UserProfile' } & Pick<
                        Types.UserProfile,
                        | 'situationWhatIsYourCurrentPropertyGoal'
                        | 'situationAreYouAFirstTimeBuyer'
                        | 'situationAreYouSellingAProperty'
                        | 'situationIsItAlreadyOnTheMarket'
                        | 'situationAreYouAPropertyInvestor'
                        | 'situationAreYouLookingToBuy'
                        | 'situationAreYouAHomeowner'
                    >
                >;
                trackedProperties?: Types.Maybe<
                    { __typename?: 'UserTrackedProperties' } & Pick<
                        Types.UserTrackedProperties,
                        'total'
                    > & {
                            items: Array<
                                { __typename?: 'UserTrackedProperty' } & Pick<
                                    Types.UserTrackedProperty,
                                    'relationship'
                                > & {
                                        property: {
                                            __typename?: 'Property';
                                        } & Pick<Types.Property, 'uprn'> & {
                                                address?: Types.Maybe<
                                                    {
                                                        __typename?: 'Address';
                                                    } & Pick<
                                                        Types.Address,
                                                        'fullAddress' | 'uprn'
                                                    >
                                                >;
                                                saleEstimate?: Types.Maybe<
                                                    {
                                                        __typename?: 'SaleEstimate';
                                                    } & Pick<
                                                        Types.SaleEstimate,
                                                        | 'lowerPrice'
                                                        | 'currentPrice'
                                                        | 'upperPrice'
                                                        | 'confidenceLevel'
                                                    >
                                                >;
                                            };
                                    }
                            >;
                        }
                >;
            }
    >;
};

export const GetUserProfileDocument = gql`
    query getUserProfile {
        user {
            loggedIn
            userId
            profile {
                situationWhatIsYourCurrentPropertyGoal
                situationAreYouAFirstTimeBuyer
                situationAreYouSellingAProperty
                situationIsItAlreadyOnTheMarket
                situationAreYouAPropertyInvestor
                situationAreYouLookingToBuy
                situationAreYouAHomeowner
            }
            trackedProperties(offset: 0, limit: 1) {
                total
                items {
                    relationship
                    property {
                        uprn
                        address {
                            fullAddress
                            uprn
                        }
                        saleEstimate {
                            lowerPrice
                            currentPrice
                            upperPrice
                            confidenceLevel
                        }
                    }
                }
            }
        }
    }
`;

/**
 * __useGetUserProfileQuery__
 *
 * To run a query within a React component, call `useGetUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetUserProfileQuery,
        GetUserProfileQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>(
        GetUserProfileDocument,
        options
    );
}
export function useGetUserProfileLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserProfileQuery,
        GetUserProfileQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserProfileQuery,
        GetUserProfileQueryVariables
    >(GetUserProfileDocument, options);
}
export type GetUserProfileQueryHookResult = ReturnType<
    typeof useGetUserProfileQuery
>;
export type GetUserProfileLazyQueryHookResult = ReturnType<
    typeof useGetUserProfileLazyQuery
>;
export type GetUserProfileQueryResult = Apollo.QueryResult<
    GetUserProfileQuery,
    GetUserProfileQueryVariables
>;
